module.exports = __webpack_public_path__ + "images/94254d04a1e5ce142a42c214f2771102.svg";